import { Action, ActionType } from "models/stressCheck/deleteStressCheck";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface DeleteStressCheckReducerType {
  loading: boolean;
  error?: any;
  deleted: boolean;
  deleteStressCheckResponse?: IResponse;
}

const defaultState: DeleteStressCheckReducerType = {
  loading: false,
  error: null,
  deleted: false,
  deleteStressCheckResponse: undefined,
};

export const deleteStressCheckReducer =
  createReducer<DeleteStressCheckReducerType>(defaultState, {
    [ActionType.DELETE_STRESS_CHECK](state: DeleteStressCheckReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DELETE_STRESS_CHECK_ERROR](
      state: DeleteStressCheckReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        deleted: false,
        error: action.payload,
      };
    },

    [ActionType.DELETE_STRESS_CHECK_SUCCESS](
      state: DeleteStressCheckReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        deleted: true,
        deleteStressCheckResponse: action.payload,
      };
    },

    [ActionType.RESET_DELETE_STRESS_CHECK](
      state: DeleteStressCheckReducerType
    ) {
      return {
        ...state,
        loading: false,
        deleted: false,
        error: null,
        deleteStressCheckResponse: undefined,
      };
    },
  });
